import localforage from "localforage";

export interface OfflineStore {
  keys(callback?: (err: any, keys: string[]) => void): Promise<string[]>;
  setItem<T>(
    key: string,
    value: T,
    callback?: (err: any, value: T) => void
  ): Promise<T>;
  getItem<T>(
    key: string,
    callback?: ((err: any, value: T | null) => void) | undefined
  ): Promise<T | null>;
  removeItem(key: string, callback?: (err: any) => void): Promise<void>;
}

export const bibleStore = localforage.createInstance({
  name: "bibleStore",
  driver: localforage.INDEXEDDB
});
